var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-box empty-banner"},[_c('i',{staticClass:"iconfont iconwenjian icon"}),_c('div',{staticClass:"g-font-mid label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }